import React from 'react';
import { Trans } from 'react-i18next';
import { ReactComponent as LinkTo } from '../../../assets/svg/LinkTo.svg';
import { translit1 } from '../../../components/common';
import { useLanguage } from '../../../hooks';
import NoCover from '../../../img/no-cover.svg';
import { MediaType, MediaUnit, ProductUnit, TVUnit } from '../../../services/content_v1';

interface WelcomeContentProps {
    type: MediaType,
    title: string,
    items: (MediaUnit | TVUnit | ProductUnit)[]
}

const WelcomeContent: React.FC<WelcomeContentProps> = ({ type, title, items }) => {
    const lang = useLanguage();

    return (items.length || 0) > 0 && (
        <section className="welcome-section">
            <div className="welcome-section__back"></div>
            <div className="welcome-section__body">
                <section className="welcome-content">
                    <header className="welcome-header">
                        <h2 className="welcome-header__heading">
                            <a href={`/${lang}/public-showcase/${type}`}>
                                {title}
                                <LinkTo />
                            </a>
                        </h2>
                        <div className="welcome-header__link">
                            <a href={`/${lang}/public-showcase/${type}`}>
                                <Trans>See all</Trans>
                                <LinkTo />
                            </a>
                        </div>
                    </header>

                    <div className="welcome-content__list">
                        {items.map((item, index) => (
                            <div key={index} className="welcome-content__list-item">
                                <article className="welcome-content__item">
                                    <div className="welcome-content__item-image">
                                        {item.covers?.at(0) ?
                                            // <ImageLoader className="w-full" url={item.covers?.at(0)} alt="" />
                                            <img className="w-full" src={item.covers?.at(0)} alt="" decoding="async" loading="lazy" style={{ objectFit: 'cover'}} />
                                            :
                                            <img src={NoCover} alt="" />
                                        }
                                    </div>
                                    <div className="welcome-content__item-name">
                                        {/* TODO XXX */}
                                        {type === 'media' && <a href={`/${lang}/public-showcase/media/${item.id}_${translit1((item as MediaUnit).title) || '_'}`}>{(item as MediaUnit).title}</a>}
                                        {type === 'tv' && <a href={`/${lang}/public-showcase/tv/${item.id}_${translit1((item as TVUnit).title) || '_'}`}>{(item as TVUnit).title}</a>}
                                        {type === 'product' && <a href={`/${lang}/public-showcase/product/${item.id}_${translit1((item as ProductUnit).name) || '_'}`}>{(item as ProductUnit).name}</a>}
                                    </div>
                                </article>
                            </div>
                        ))}
                    </div>
                </section>
            </div>
        </section>
    );
};

export default WelcomeContent;